import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD
} from "../../../../../../constants";

import customerItemToBagSuccess from "./customerItemToBagSuccess";
import sharedBoardItemToBagSuccess from "./sharedBoardItemToBagSuccess";

export default (state, { payload: { itemsType, id } }) => {
  const actionMap = {
    [ITEMS_TYPE_CUSTOMER_ITEMS]: () => customerItemToBagSuccess({ state, id }),
    [ITEMS_TYPE_SHARED_BOARD]: () => sharedBoardItemToBagSuccess({ state, id })
  };

  return actionMap[itemsType]();
};
